// extracted by mini-css-extract-plugin
export default {"main":"_00ddc7a963 _6070c84fcb e5a7d0b6e1 c1bc6503b7","title":"b638ccd61d"};